class WPDevice {
  id = null;
  name = "";
  phone = "";
  slug = "";
  userid = null;
  activeuserid = null;

  createdby = null;
  updatedby = null;
}

export default WPDevice;
